import React from 'react';

import { Box, Typography } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize, LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';
import { formatCicDateTime, getCicDisplayValue } from 'utils/cicReason';

import { CicBundleChipTitle } from '../../LoanCicHistory.constants';
import { LoanCicHistoryTestIds } from '../../LoanCicHistory.testIds';
import { getDeliveryStatusLabel } from '../../LoanCicHistory.utils';

import { CicDisclosureColumnId } from './CicSentDisclosures.constants';
import {
  disclosureCellStyles,
  documentsCellStyles,
  expandIconStyles,
} from './CicSentDisclosures.styles';
import CicDisclosureDocumentLink from './components/CicDisclosureDocumentLink';

const renderExpandCell = expandedRowId => row => (
  <Box sx={expandIconStyles}>
    <ArrowCheckIcon
      direction={expandedRowId === row.id ? IconDirection.DOWN : IconDirection.RIGHT}
      size={IconSize[16]}
    />
  </Box>
);

const renderDisclosureCell = ({ id, bundleType, title }) => (
  <Box sx={disclosureCellStyles}>
    <LabelCDS
      size={LabelSize.S}
      title={CicBundleChipTitle[bundleType]}
      variant={LabelVariant.BLUE}
    />
    <Typography
      color="text.primary"
      data-testid={LoanCicHistoryTestIds.getDisclosureTitleId(id)}
      variant="medium14"
    >
      {title}
    </Typography>
  </Box>
);

const renderSentCell = ({ sentDate }) => (
  <Typography variant="regular14">{getCicDisplayValue(formatCicDateTime(sentDate))}</Typography>
);

const renderDeliveryCell = ({ id, deliveryStatus }) => {
  const { title, variant } = getDeliveryStatusLabel(deliveryStatus);

  return (
    <Box data-testid={LoanCicHistoryTestIds.getDisclosureDeliveryId(id)}>
      <LabelCDS size={LabelSize.S} title={title} variant={variant} />
    </Box>
  );
};

const renderDocumentsCell = ({ id, documents, sentDate }) => (
  <Box sx={documentsCellStyles}>
    {documents.map(({ documentId, name }) => (
      <CicDisclosureDocumentLink
        formDeliveryRequestId={id}
        key={documentId}
        name={name}
        sentDate={sentDate}
      />
    ))}
  </Box>
);

export const getCicDisclosuresTableConfig = ({ expandedRowId }) => ({
  [CicDisclosureColumnId.EXPAND]: {
    label: '',
    width: '40px',
    content: renderExpandCell(expandedRowId),
  },
  [CicDisclosureColumnId.DISCLOSURE]: {
    label: 'Disclosure',
    width: '38%',
    content: renderDisclosureCell,
  },
  [CicDisclosureColumnId.SENT]: {
    label: 'Sent',
    width: '20%',
    content: renderSentCell,
  },
  [CicDisclosureColumnId.DELIVERY]: {
    label: 'Delivery',
    width: '16%',
    content: renderDeliveryCell,
  },
  [CicDisclosureColumnId.DOCUMENTS]: {
    label: 'Documents',
    width: '22%',
    content: renderDocumentsCell,
  },
});
